import { useSelector } from 'react-redux';

const DynamicPageTitle = () => {
  const pageTitle = useSelector((state) => state.pageReducer.pageTitle);
  return pageTitle;
};

const dynamicRoutes = [
  {
    path: '/contents/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/tags/contents/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/subjects/contents/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/subjects/contents/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/resource-categories/contents/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/tickets/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/support/tickets/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/bulletins/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
  {
    path: '/resources/:platform/:id',
    breadcrumb: DynamicPageTitle,
    props: {
      shouldTranslate: false,
    },
  },
];

const routesWithCustomLink = [
  {
    path: '/contents',
    props: {
      link: '/contents/:platformId',
      feature: 'contents',
    },
  },
  {
    path: '/tags/contents',
    props: {
      link: '/tags/contents/:platformId',
      feature: 'contents',
    },
  },
  {
    path: '/subjects/contents',
    props: {
      link: '/subjects/contents/:platformId',
      feature: 'contents',
    },
  },
  {
    path: '/statistics',
    props: {
      link: '/statistics/:platformId',
      feature: 'statistics',
    },
  },
  {
    path: '/tags/statistics',
    props: {
      link: '/tags/statistics/:platformId',
      feature: 'statistics',
    },
  },
  {
    path: '/subjects/statistics',
    props: {
      link: '/subjects/statistics/:platformId',
      feature: 'statistics',
    },
  },
  {
    path: '/resources',
    props: {
      link: '/resources/:platformId',
      feature: 'resources',
    },
  },
  {
    path: '/resource-categories/vip',
    props: {
      link: '/resource-categories/vip/:platformId',
      feature: 'vipResources',
    },
  },
  {
    path: '/resource-categories/blacklist',
    props: {
      link: '/resource-categories/blacklist/:platformId',
      feature: 'blacklist',
    },
  },
];

const routesWithCustomTranslateKey = [
  {
    path: '/brandbaan',
    props: {
      translateKey: 'brandBaan',
    },
  },
  {
    path: '/subjects/add',
    props: {
      translateKey: 'addSubject',
    },
  },
  {
    path: '/subjects/edit',
    props: {
      translateKey: 'editSubject',
    },
  },
  {
    path: '/alarms/add',
    props: {
      translateKey: 'addAlarm',
    },
  },
  {
    path: '/alarms/edit',
    props: {
      translateKey: 'editAlarm',
      shouldBehaveAsLast: true,
    },
  },
  {
    path: '/resource-categories/vip/add',
    props: {
      translateKey: 'addVip',
    },
  },
  {
    path: '/resource-categories/blacklist/add',
    props: {
      translateKey: 'addEditBlacklist',
    },
  },
  {
    path: '/resource-categories/add',
    props: {
      translateKey: 'addCategory',
    },
  },
  {
    path: '/comparisons/add',
    props: {
      translateKey: 'addComparison',
    },
  },
  {
    path: '/companies/add',
    props: {
      translateKey: 'addCompany',
    },
  },
  {
    path: '/companies/edit',
    props: {
      translateKey: 'editCompany',
    },
  },
  {
    path: '/users/add',
    props: {
      translateKey: 'addUser',
    },
  },
  {
    path: '/users/edit',
    props: {
      translateKey: 'editUser',
    },
  },
];

const disabledRoutes = [
  {
    path: '/contents/instagramStory/',
    props: {
      shouldBehaveAsLast: true,
    },
  },
  {
    path: '/resource-categories/edit',
    props: {
      translateKey: 'editCategory',
      shouldBehaveAsLast: true,
    },
  },
  {
    path: '/bulletins/smart',
    props: {
      shouldBehaveAsLast: true,
    },
  },
];

const hiddenRoutes = [
  {
    path: '/subjects/edit/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/edit-source/:id/',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/edit-subject/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/source/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/source/:id/:platform',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/subject/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/comparisons/subject/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/resource-categories/edit/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/bulletins/smart/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/alarms/edit/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/companies/edit/:id',
    props: {
      isVisible: false,
    },
  },
  {
    path: '/users/edit/:id',
    props: {
      isVisible: false,
    },
  },
];

export const routes = [
  ...dynamicRoutes,
  ...routesWithCustomLink,
  ...routesWithCustomTranslateKey,
  ...disabledRoutes,
  ...hiddenRoutes,
];
